export function hasAuth (authorisationName, permissions) {
  return !!(permissions && !!permissions.length && permissions.find(({ name }) => name === authorisationName))
}
